import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Welcome from './Welcome';
import Services from './Services';
import Back from './Back';
import About from './About';
import TeamIntro from './TeamIntro';
import Practice from './Practice';
import Jobs from './Jobs';
import { LanguageProvider } from './LanguageContext';

const App = () => {
  const pageWrapperStyle = {
    backgroundColor: 'white',
    minHeight: '100vh',
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  };

  const appStyle = {
    width: '100%',
    maxWidth: '768px',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: 'white',
    position: 'relative'
  };

  const contentStyle = {
    flex: '1',
    overflowY: 'auto',
    marginTop: '60px',
    marginBottom: '60px',
    width: '100%'
  };

  return (
    <LanguageProvider>
      <div style={pageWrapperStyle}>
        <div style={appStyle}>
          <Header />
          <div style={contentStyle}>
            <Welcome />
            <Services />
            <Back />
            {/* <Veronik />
            <Team />
            <Contact /> */}
            <About />
            <TeamIntro />
            {/* <Jobs /> */}
            <Practice />
          </div>
        <Footer />
      </div>
      </div>
    </LanguageProvider>
  );
};

export default App;
